import { useStrings } from "@1js/localization-components";
import { PromptIcon, generateTitleFromPrompt } from "@1js/pl-card-components";
import type { Prompt } from "@1js/pl-types";
import {
  Text,
  makeStyles,
  mergeClasses,
  shorthands,
  tokens,
} from "@fluentui/react-components";
import * as React from "react";
import { useFlightContext } from "../../hooks/useFlightContext";
import { TryThisPromptLabel } from "./PromptDetailTitle.web.string";

type Props = {
  prompt: Prompt;
};

const useStyles = makeStyles({
  title: {
    display: "flex",
    alignItems: "center",
    alignSelf: "stretch",
    ...shorthands.gap("4px"),
  },

  titleText: {
    color: tokens.colorNeutralForeground1,
    textOverflow: "ellipsis",
    whitespace: "nowrap",
    display: "-webkit-box",
    WebkitLineClamp: "2",
    WebkitBoxOrient: "vertical",
    fontSize: "1.5rem",
    fontStyle: "normal",
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: "2rem",
    ...shorthands.overflow("hidden"),
  },

  smallerTitleOnMobile: {
    "@media (max-width: 540px)": {
      fontSize: "1.25rem",
      lineHeight: "normal",
    },
  },
});

export const PromptDetailTitle: React.FC<Props> = ({ prompt }) => {
  const styles = useStyles();
  const localizations = useStrings({
    TryThisPromptLabel,
  });
  let title = prompt.Title || generateTitleFromPrompt(prompt);
  const { isFlightActive } = useFlightContext();
  const isGoBoldEnabled = isFlightActive("isGoBoldPromptCardEnabled");
  if (isGoBoldEnabled) {
    title = localizations.TryThisPromptLabel();
  }

  return (
    <div className={styles.title}>
      {!isGoBoldEnabled && <PromptIcon prompt={prompt} appearance="web" />}
      <Text
        data-testid="detail-title"
        className={mergeClasses(
          styles.titleText,
          !isGoBoldEnabled && styles.smallerTitleOnMobile
        )}
      >
        {title}
      </Text>
    </div>
  );
};
